import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type TournamentTab = "Ongoing" | "Upcoming" | "Completed";

interface TournamentsTabState {
  value: TournamentTab;
}

const initialState: TournamentsTabState = { value: "Ongoing" };

const tournamentsTabSlice = createSlice({
  name: "tournamentsTab",
  initialState,
  reducers: {
    setTournamentsTab(state, action: PayloadAction<TournamentTab>) {
      state.value = action.payload;
    },
    resetTournamentsTab() {
      return initialState;
    },
  },
});

export const { setTournamentsTab, resetTournamentsTab } = tournamentsTabSlice.actions;
export default tournamentsTabSlice.reducer;
